'use strict';

let module = {};

(function (module) {

    var routes = function ($stateProvider, baseState) {

        $stateProvider

            .state('' + baseState + '.clerk-ledgers', {
                abstract: true,
                url: "/ledgers",
                template: "<ui-view/>"
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-ledgers'] = {
            template: require("crud/clerk-ledger/list.html"),
            controller: "listClerkLedgersController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledgers.list', {
                url: "/list",
                views: views,
                data: {pageTitle: 'List Ledgers'}
            })

            ;

        var views = {};
        views['@' + baseState + '.clerk-ledgers'] = {
            template: "<ui-view/>",
            controller: "listClerkLedgersController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledgers.curate', {
                abstract: true,
                url: "/curate",
                views: views,
                data: {pageTitle: 'Curate Ledgers'}
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic instead of repeated code
            .state('' + baseState + '.clerk-ledgers.curate.continue-editing', {
                url: "/continue-editing",
                data: {
                    pageTitle: 'Curate Ledger - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                },
                template: require("crud/clerk-ledger/curate-steps/attributes.html"),
                controller: "listClerkLedgersController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'attributes';
                    },
                }
            })

            // "Attributes"
            .state('' + baseState + '.clerk-ledgers.curate.attributes', {
                url: "/attributes",
                data: {
                    pageTitle: 'Curate Ledger - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                },
                template: require("crud/clerk-ledger/curate-steps/attributes.html"),
                controller: "listClerkLedgersController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'attributes';
                    },
                }
            })

            // "Persistence"
            .state('' + baseState + '.clerk-ledgers.curate.persistence', {
                url: "/persistence",
                data: {
                    pageTitle: 'Curate Ledger - Step \'persistence\'',
                    stepCaption: "Persistence",
                    stepMetadata: {"stepReference":"persistence","step":"persistence"},
                },
                template: require("crud/clerk-ledger/curate-steps/persistence.html"),
                controller: "listClerkLedgersController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'persistence';
                    },
                }
            })

            // "Review & Approve"
            .state('' + baseState + '.clerk-ledgers.curate.review-and-approve', {
                url: "/review-and-approve",
                data: {
                    pageTitle: 'Curate Ledger - Step \'review-and-approve\'',
                    stepCaption: "Review & Approve",
                    stepMetadata: {"stepReference":"review-and-approve","step":"review-and-approve"},
                },
                template: require("crud/clerk-ledger/curate-steps/review-and-approve.html"),
                controller: "listClerkLedgersController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'review-and-approve';
                    },
                }
            })

            // "Exported Files"
            .state('' + baseState + '.clerk-ledgers.curate.exported-files', {
                url: "/exported-files",
                data: {
                    pageTitle: 'Curate Ledger - Step \'exported-files\'',
                    stepCaption: "Exported Files",
                    stepMetadata: {"stepReference":"exported-files","step":"exported-files"},
                },
                template: require("crud/clerk-ledger/curate-steps/exported-files.html"),
                controller: "listClerkLedgersController",
                resolve: {
                    setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                        routeBasedVisibilitySettings.ClerkLedger_columns_by_step = 'exported-files';
                    },
                }
            })


            .state('' + baseState + '.clerk-ledgers.create', {
                url: "/new",
                onEnter: /*@ngInject*/ function ($state, clerkLedger, clerkLedgers) {
                    let itemAttributes = {
                        'attributes': {
                        }
                    };
                    clerkLedgers.add(itemAttributes, function (createdItem) {
                        let goToStateParams = angular.merge($state.params, {activeClerkLedgerId: createdItem.id});
                        $state.transitionTo(
                            '' + baseState + '.clerk-ledgers.existing.edit.continue-editing',
                            goToStateParams,
                            {location: 'replace', inherit: true, relative: $state.$current, notify: true}
                        );
                    });
                },
                data: {pageTitle: 'New Ledger'}
            })

            ;

        var views = {};
        views['@' + '' + baseState + '.clerk-ledgers'] = {
            template: require("./clerk-ledger-wrapper.html"),
            controller: "editClerkLedgerController",
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledgers.existing', {
                abstract: true,
                url: "/:activeClerkTaxEntityId/:activeClerkLedgerId",
                data: {
                    stepCaption: "Ledger",
                },
                resolve: {
                    setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1A, routeBasedContentFilters, $stateParams) {
                        routeBasedContentFilters.ClerkLedgerEntry_order = 'ClerkLedgerEntry.official_ordinal ASC';
                        routeBasedContentFilters.ClerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                        routeBasedContentFilters.ClerkLedgerEntryRow_clerkLedgerEntry_clerk_ledger_id = $stateParams.activeClerkLedgerId;
                        routeBasedContentFilters.ClerkLedgerEntryRow_order = 'ClerkLedgerEntry.official_ordinal DESC, ClerkLedgerEntryRow.ordinal';
                    },
                    setRouteBasedVisibilitySettingsLevel1: /*@ngInject*/ function (setRouteBasedVisibilitySettingsLevel0, routeBasedVisibilitySettings, $stateParams) {
                        // TODO: Adjust the below so that columns that are all the same value due to a route-based filter are hidden
                        routeBasedVisibilitySettings.ClerkLedger_hide_source_relation = 'ClerkLedger';
                    },
                    currentClerkTaxEntity: /*@ngInject*/ function (dataEnvironmentParam, $stateParams, clerkTaxEntity) {

                        clerkTaxEntity.$activate();
                        return clerkTaxEntity.load($stateParams.activeClerkTaxEntityId);

                    },
                    currentClerkLedger: /*@ngInject*/ function ($stateParams, clerkLedger) {
                        let activeClerkLedgerId = $stateParams.activeClerkLedgerId;
                        clerkLedger.$activate();
                        return clerkLedger.load(activeClerkLedgerId);
                    },
                },
                views: views,
            })

            /*
             .state('' + baseState + '.clerk-ledgers', {
             url: "/dashboard",
             template: require("crud/clerk-ledger/dashboard.html"),
             data: {pageTitle: 'Ledgers Dashboard'}
             })
             */

            ;

        var views = {};
        views['@' + baseState + '.clerk-ledgers'] = {
            controller: "editClerkLedgerController",
            template: require("crud/clerk-ledger/view.html"),
        };

        $stateProvider

            .state('' + baseState + '.clerk-ledgers.existing.view', {
                url: "/view",
                views: views,
                data: {pageTitle: 'View Ledger'}
            })


            ;

        var views = {};
        views['@' + baseState + '.clerk-ledgers'] = {
            controller: "editClerkLedgerController",
            template: require("crud/clerk-ledger/components/form.html")
        };
        /*
        views['sidebar@root'] = {
            template: require("crud/clerk-ledger/navigation.html")
        };
        */

        $stateProvider

            .state('' + baseState + '.clerk-ledgers.existing.edit', {
                abstract: true,
                url: "/edit",
                views: views,
                data: {
                    showSideMenu: true,
                    pageTitle: 'Edit Ledger'
                }
            })

            // Add initial alias for "first-step" TODO: Refactor to have dynamic step logic in angular logic
            .state('' + baseState + '.clerk-ledgers.existing.edit.continue-editing', {
                url: "/continue-editing",
                template: require("crud/clerk-ledger/steps/attributes.html"),
                data: {pageTitle: 'Edit Ledger'}
            })

            // "Attributes"
            .state('' + baseState + '.clerk-ledgers.existing.edit.attributes', {
                url: "/attributes",
                template: require("crud/clerk-ledger/steps/attributes.html"),
                data: {
                    pageTitle: 'Edit Ledger - Step \'attributes\'',
                    stepCaption: "Attributes",
                    stepMetadata: {"stepReference":"attributes","step":"attributes"},
                }
            })

            .state('' + baseState + '.clerk-ledgers.existing.edit.attributes.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "id" TYPE primary-key TODO scrollto/mark -->

            // "remote_source_tag_spec" TYPE ordinary TODO scrollto/mark -->

            // "clerkTaxEntity" TYPE has-one-relation TODO scrollto/mark -->

            // "clerkFiscalYear" TYPE has-one-relation TODO scrollto/mark -->

            // "label" TYPE ordinary TODO scrollto/mark -->

            // "previousClerkLedger" TYPE has-one-relation TODO scrollto/mark -->

            // "closing_year_depreciations_amount" TYPE ordinary TODO scrollto/mark -->

            // "closing_year_anticipated_audit_expense_amount" TYPE ordinary TODO scrollto/mark -->

            // "closing_year_income_tax_amount" TYPE ordinary TODO scrollto/mark -->

            // "closing_year_income_tax_amount" TYPE ordinary TODO scrollto/mark -->

            // "closing_year_calculated_income_tax_amount" TYPE ordinary TODO scrollto/mark -->

            // "closing_year_se_work_from_private_property_deduction_amount" TYPE ordinary TODO scrollto/mark -->

            // "clerkBasisOfAccounting" TYPE has-one-relation TODO scrollto/mark -->

            // "ledger_record_persists_forecasting" TYPE ordinary TODO scrollto/mark -->

            // "minimal_work_maximal_inclusion_threshold" TYPE ordinary TODO scrollto/mark -->

            // "forecasting_param_skip_opening_the_year" TYPE ordinary TODO scrollto/mark -->

            // "forecasting_param_skip_closing_the_year" TYPE ordinary TODO scrollto/mark -->

            // "forecasting_param_up_until_and_including_date" TYPE ordinary TODO scrollto/mark -->

            // "persists_forecasting_up_until_and_including_date" TYPE ordinary TODO scrollto/mark -->

            // "last_forecasted_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "key_combo" TYPE ordinary TODO scrollto/mark -->

            // "most_recent_interpretation_of_clue_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "created" TYPE ordinary TODO scrollto/mark -->

            // "modified" TYPE ordinary TODO scrollto/mark -->

            // "node" TYPE internal TODO scrollto/mark -->

            // "clerkDataset" TYPE internal TODO scrollto/mark -->

            // "economacs_uid" TYPE ordinary TODO scrollto/mark -->

            // "economacs_used_for_accounting" TYPE ordinary TODO scrollto/mark -->

            // "Persistence"
            .state('' + baseState + '.clerk-ledgers.existing.edit.persistence', {
                url: "/persistence",
                template: require("crud/clerk-ledger/steps/persistence.html"),
                data: {
                    pageTitle: 'Edit Ledger - Step \'persistence\'',
                    stepCaption: "Persistence",
                    stepMetadata: {"stepReference":"persistence","step":"persistence"},
                }
            })

            .state('' + baseState + '.clerk-ledgers.existing.edit.persistence.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "ledger_contents_pf" TYPE ordinary TODO scrollto/mark -->

            // "Review & Approve"
            .state('' + baseState + '.clerk-ledgers.existing.edit.review-and-approve', {
                url: "/review-and-approve",
                template: require("crud/clerk-ledger/steps/review-and-approve.html"),
                data: {
                    pageTitle: 'Edit Ledger - Step \'review-and-approve\'',
                    stepCaption: "Review & Approve",
                    stepMetadata: {"stepReference":"review-and-approve","step":"review-and-approve"},
                }
            })

            .state('' + baseState + '.clerk-ledgers.existing.edit.review-and-approve.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "status_needs_bookkeeping" TYPE ordinary TODO scrollto/mark -->

            // "status_needs_accounting_support" TYPE ordinary TODO scrollto/mark -->

            // "status_prepared_for_accounting" TYPE ordinary TODO scrollto/mark -->

            // "status_awaiting_approval" TYPE ordinary TODO scrollto/mark -->

            // "status_archived" TYPE ordinary TODO scrollto/mark -->

            // "status_needs_correction" TYPE ordinary TODO scrollto/mark -->

            // "has_done_what_is_mandatory" TYPE ordinary TODO scrollto/mark -->

            // "worth_doing_more_than_what_is_mandatory" TYPE ordinary TODO scrollto/mark -->

            // "required_to_enter_in_the_books" TYPE ordinary TODO scrollto/mark -->

            // "worth_entering_in_the_books" TYPE ordinary TODO scrollto/mark -->

            // "has_entered_in_the_books_what_is_mandatory" TYPE ordinary TODO scrollto/mark -->

            // "has_been_opened" TYPE ordinary TODO scrollto/mark -->

            // "worth_entering_more_in_the_books_than_what_is_mandatory" TYPE ordinary TODO scrollto/mark -->

            // "worth_including_more_ledger_entries" TYPE ordinary TODO scrollto/mark -->

            // "worth_documenting_more_ledger_entries" TYPE ordinary TODO scrollto/mark -->

            // "worth_archiving_more_supporting_documents" TYPE ordinary TODO scrollto/mark -->

            // "worth_finding_more_missing_documents" TYPE ordinary TODO scrollto/mark -->

            // "worth_putting_more_documents_in_place" TYPE ordinary TODO scrollto/mark -->

            // "worth_improving_documents" TYPE ordinary TODO scrollto/mark -->

            // "worth_summarizing_more_business_events" TYPE ordinary TODO scrollto/mark -->

            // "worth_summarizing_more_business_events_prior_to_locked_date" TYPE ordinary TODO scrollto/mark -->

            // "outdated" TYPE ordinary TODO scrollto/mark -->

            // "acceptably_outdated" TYPE ordinary TODO scrollto/mark -->

            // "info_about_recent_business_events_missing" TYPE ordinary TODO scrollto/mark -->

            // "active_accounting_preparations_ongoing" TYPE ordinary TODO scrollto/mark -->

            // "active_human_refinement_ongoing" TYPE ordinary TODO scrollto/mark -->

            // "preparations_complete_for_now" TYPE ordinary TODO scrollto/mark -->

            // "active_accounting_work_ongoing" TYPE ordinary TODO scrollto/mark -->

            // "accounting_up_to_date" TYPE ordinary TODO scrollto/mark -->

            // "accounting_up_to_date_and_imported" TYPE ordinary TODO scrollto/mark -->

            // "has_been_closed" TYPE ordinary TODO scrollto/mark -->

            // "audit_required" TYPE ordinary TODO scrollto/mark -->

            // "sent_to_auditor_utc_datetime" TYPE ordinary TODO scrollto/mark -->

            // "audit_approved" TYPE ordinary TODO scrollto/mark -->

            // "correction_required" TYPE ordinary TODO scrollto/mark -->

            // "Exported Files"
            .state('' + baseState + '.clerk-ledgers.existing.edit.exported-files', {
                url: "/exported-files",
                template: require("crud/clerk-ledger/steps/exported-files.html"),
                data: {
                    pageTitle: 'Edit Ledger - Step \'exported-files\'',
                    stepCaption: "Exported Files",
                    stepMetadata: {"stepReference":"exported-files","step":"exported-files"},
                }
            })

            .state('' + baseState + '.clerk-ledgers.existing.edit.exported-files.attributes', {
                abstract: true,
                template: "<ui-view/>"
            })

            // "seGeneratedSieFile" TYPE has-one-relation TODO scrollto/mark -->

            // "se_sie_file_generated_utc_datetime" TYPE ordinary TODO scrollto/mark -->



        ;

    };

    module.routes = routes;

    /*
     Usage example:
     someAngularModuleThatRequiresThisItemsCrudRouting.config(function ($stateProvider) {
         routes($stateProvider, 'root.api-endpoints.existing');
     });
     */

})(module);

export default module;



// WEBPACK FOOTER //
// .-dna/app/crud/clerk-ledger/routes.js